const createSite = {
  form: {
    header: {
      title: 'Hola',
    },

    fields: {
      sitePlaceHolder: 'Por favor, introduzca el nombre de su sitio',
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: '¿Qué escenario le gustaría transmitir con moovex?',
        instructions: 'Por favor, marca el campo que más describe tu zona de actividad.',
      },
    },

    button: 'QUIERO Construir un escenario',
  },
};

export default createSite;
